import { IIsiDtoPlDesignResult, IsiDtoPlDesignRequest, IsiDtoPlDesignResponse, IsiDtoPlDesignResult } from "../../Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlDesign";
import { IIsiUIFlowResultGeneric } from "../Core/IIsiUIFlowResultGeneric";
import { IsiPresentationLogic } from "./IsiPresentationLogic";



export class IsiPlDesign extends IsiPresentationLogic {

    constructor() {
        super("IsiPlDesignHandler");
    }
    /*
    * Traitement permettant de tester l'écran actuellement en cours d'édition de design
    */
    public async ManageAuthCookieUpdate(fromBandeau: string, desk: number, profil: string): Promise<string> {
        let params = IsiDtoPlDesignRequest.fromJS({
            connectFromBandeau: fromBandeau,
            deskCode: desk,
            profileCode: profil,
            response: IsiDtoPlDesignResponse.fromJS({
            })
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlDesignRequest> = await this.ajaxWithErrorHandling("ManageAuthCookieUpdate", params, true);

        return result?.reponse?.response?.returnedResponse;
    }

    /*
    * Traitement permettant d'activer le mode développeur en édition de design
    */
    public async CheckDevMode(): Promise<string> {
        let params = IsiDtoPlDesignRequest.fromJS({
            response: IsiDtoPlDesignResponse.fromJS({
            })
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlDesignRequest> = await this.ajaxWithErrorHandling("CheckDevMode", params, true);

        return result?.reponse?.response?.returnedResponse;
    }

    /*
    * Permet de recuperé les controles System désactivé 
    */
    public async getDisabledSysCtrls(screenCode: string, moduleCode: string, deskCode: number): Promise<IsiDtoPlDesignResponse> {
        let params = IsiDtoPlDesignRequest.fromJS({
            screenCode: screenCode,
            moduleCode: moduleCode,
            deskCode: deskCode,
            response: IsiDtoPlDesignResponse.fromJS({
                result: IsiDtoPlDesignResult.fromJS({})
            })
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlDesignRequest> = await this.ajaxWithErrorHandling("LoadDisabledSysCtrls", params, true);

        return result?.reponse?.response;
    }


    /*
    * Traitement permettant de récupéré les valeurs des controles systèmes sur l'écran design 
    */
    public async loadSysCtrls(screenCode: string, moduleCode: string, deskCode: number, isRwd: boolean, ctrlCode: string): Promise<string> {
        let params = IsiDtoPlDesignRequest.fromJS({
            screenCode: screenCode,
            moduleCode: moduleCode,
            deskCode: deskCode,
            isRwd: isRwd,
            ctrlCode: ctrlCode,
            response: IsiDtoPlDesignResponse.fromJS({
            })
        });
        const result: IIsiUIFlowResultGeneric<IsiDtoPlDesignRequest> = await this.ajaxWithErrorHandling("LoadSysCtrl", params, true);

        return result?.reponse?.response?.result.sysCtrlsValue;
    }
}